/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { DateRangePicker, Divider } from "rsuite";
import { getCloudIdLog } from "./_redux/monitorCrud";
import { subDays } from "date-fns";
import CalendarIcon from "../../../icons/calendar.svg";
import Moment from "moment";
import cloudlog from "../../../icons/cloudlog.svg";
import Refresh from "../../../icons/Refresh.svg";
import Download_svg from "../../../icons/Download_svg.svg";
import DownArrow from "../../../icons/DownArrow.svg";
import Pagination from "@material-ui/lab/Pagination";
import { RecordsperPage } from "../../../Application_Constants";
const { afterToday } = DateRangePicker;
export default function NewDateRange(props) {
  const [date, setDate] = useState([subDays(new Date(), 6), new Date()]);
  const [state, setState] = useState({
    cloudIdLogData: [],
    cloudIdLogDownload: [],
    loading: false,
    errorMessage: false,
    toDate: date[1],
    fromDate: date[0],
    downloadData: [],
    monitorInputValue: "ALL",
    selectedHour: "All",
    severitySelected: "ALL",
    monitorIdList: [],
    totalCount: 0,
    paginationLoading: false,
    currentPage: 1,
    sort_order: "desc",
    sortedColumn: "created_date"
  });

  useEffect(() => {
    if (props.monitor !== null) {
      CloudActivityLog();
    }
  }, [props.monitor, state.currentPage, state.sort_order]);

  const getStartSerialNumber = () => {
    return (state.currentPage - 1) * RecordsperPage + 1;
  };

  const handlePageChange = (event, value) => {
    let pageValue = value;
    setState({
      ...state,
      currentPage: pageValue
    });
  };

  const downloadHandler = () => {
    let data = {
      time_span: state.selectedHour,
      event_severity: state.severitySelected,
      time_from: Moment(date[0].toDateString()).format(),
      time_to: Moment(date[1].setHours(23, 59, 59)).format(),
      monitor_id: state.monitorInputValue
    };

    if (props.monitor !== null) {
      getCloudIdLog(data, props.monitor.id, "-1", "1")
        .then((res) => {
          const { data, status, message } = res.data;

          if (status) {
            let arrayData = [];

            data.forEach((element) => {
              let res_data = {
                ID: Moment(element.updated_date).format("YYYYMMDD_HHmmss"),
                Description: element.type + ":" + element.activity,

                "Date/Time": Moment(element.created_date).format(
                  "MM-DD-yyyy, HH:mm:ss"
                )
              };
              arrayData.push(res_data);
            });

            const headers = Object.keys(arrayData[0]);
            const csvContent = [
              headers.join(","),
              ...arrayData.map((item) =>
                headers.map((key) => `"${item[key]}"`).join(",")
              )
            ].join("\n");

            const blob = new Blob([csvContent], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "CLoud_Log";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          } else {
            setState({
              ...state,
              errorMessage: message,
              loading: false,
              paginationLoading: false,
              totalCount: 0
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status !== 404 && error) {
              setState({
                ...state,
                cloudIdLogDownload: [],
                errorMessage: error.response.data.message,
                loading: false,
                paginationLoading: false,
                totalCount: 0
              });
            } else {
              props.history.push("error/error-v1");
            }
          } else {
            setState({
              ...state,
              cloudIdLogDownload: [],
              errorMessage: error.message,
              loading: false,
              paginationLoading: false,
              totalCount: 0
            });
          }
        });
    }
  };

  const CloudActivityLog = () => {
    let data = {
      time_span: state.selectedHour,
      event_severity: state.severitySelected,
      time_from: Moment(date[0].toDateString()).format(),
      time_to: Moment(date[1].setHours(23, 59, 59)).format(),
      monitor_id: state.monitorInputValue
    };
    if (state.currentPage !== 0) {
      setState({ ...state, loading: true, cloudIdLogData: [] });
    } else {
      setState({ ...state, paginationLoading: true });
    }
    if (props.monitor !== null) {
      getCloudIdLog(
        data,
        props.monitor.id,
        RecordsperPage,
        state.currentPage,
        state.sort_order
      )
        .then((res) => {
          const { data, status, message, count } = res.data;
          if (status) {
            setState({
              ...state,
              cloudIdLogData: data,
              loading: false,
              errorMessage: false,
              totalCount: count
            });
          } else {
            setState({
              ...state,
              errorMessage: message,
              loading: false,
              paginationLoading: false,
              totalCount: 0
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status !== 404 && error) {
              setState({
                ...state,
                cloudIdLogData: [],
                errorMessage: error.response.data.message,
                loading: false,
                paginationLoading: false,
                totalCount: 0
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            setState({
              ...state,
              cloudIdLogData: [],
              errorMessage: error.message,
              loading: false,
              paginationLoading: false,
              totalCount: 0
            });
          }
        });
    }
  };

  const refreshCloudActivity = async () => {
    CloudActivityLog();
  };

  const handleSort = (columnName) => {
    const { sortedColumn, sort_order } = state;
    const newSortBy =
      columnName === sortedColumn
        ? sort_order === "asc"
          ? "desc"
          : "asc"
        : "asc";
    setState({
      ...state,
      sort_order: newSortBy,
      sortedColumn: columnName
    });
  };
  const CloudLogOnDateChange = () => {
    if (state.currentPage !== 1) {
      setState({
        ...state,
        currentPage: 1
      });
    } else {
      CloudActivityLog();
    }
  };

  const currentcloudIdLodData = state.cloudIdLogData;
  const totalPages = Math.ceil(state.totalCount / RecordsperPage);

  return (
    <div style={{ margin: "0", marginRight: "12px" }}>
      <div className="col-sm-12 bordercss">
        <div
          style={{
            height: "56px",
            backgroundColor: "white",
            width: "100%"
          }}
        >
          {" "}
          <img className="imgcloudHeader" src={cloudlog} alt="cloudlog"></img>
          <p className="imgcloudHeaderspan"> Cloud Activity Log</p>
          <div className="col-md-12 dateRangePickercloud">
            <img src={CalendarIcon} alt="CalendarIcon" className="calendar"></img>
            <DateRangePicker
              value={date}
              onChange={setDate}
              onExit={() => {
                CloudLogOnDateChange();
              }}
              showOneCalendar
              cleanable={false}
              appearance="subtle"
              disabledDate={afterToday()}
              placeholder="Select a date or date range"
              character=" to "
              format="MM-dd-yyyy"
            />
            <button className="button-refresh" onClick={refreshCloudActivity}>
              <img className="imgCloud" src={Refresh} alt="Refresh"></img>
              <span className="imgCloudSpan">Refresh</span>
            </button>

            <button
              className="cloudlog_button"
              disabled={state.cloudIdLogData.length === 0}
              onClick={downloadHandler}
            >
              <img style={{ marginRight: "5px" }} alt="Download_svg" src={Download_svg} />
              <span id="getcloudlog">Download </span>
            </button>
          </div>
        </div>

        <Divider></Divider>
      </div>

      <div className="row">
        <div
          className="table-responsive tableFixHead font_family"
          id="monitorScroll"
          style={{ height: "55vh" }}
        >
          <table
            className="table table-hover table-striped table-hover align-middle cloudActivityLog"
            style={{ marginBottom: "0", padding: "0" }}
          >
            <thead>
              <tr>
                <th>#</th>
                <th></th>

                <th className="text">ID </th>
                <th className="text">Description</th>
                <th onClick={() => handleSort("created_date")} className="text">
                  Date / Time
                  {state.sortedColumn === "created_date" &&
                    (state.sort_order === "asc" ? (
                      <img
                        className="imgdesc"
                        style={{ paddingRight: "20px" }}
                        src={DownArrow}
                        alt="DownArrow"
                      ></img>
                    ) : (
                      <img
                        className="imgasc"
                        style={{ paddingLeft: "20px" }}
                        src={DownArrow}
                        alt="DownArrow"
                      ></img>
                    ))}
                </th>
              </tr>
            </thead>
            <tbody>
              {state.loading ? (
                <tr>
                  <td colSpan="12" align="center">
                    <div class="d-flex justify-content-center">
                      <span
                        style={{ justifyContent: "center" }}
                        className="ml-3 spinner spinner-dark "
                      ></span>
                    </div>
                  </td>
                </tr>
              ) : (
                currentcloudIdLodData &&
                currentcloudIdLodData.map((value, index) => (
                  <tr key={index.toString()}>
                    <td>{getStartSerialNumber() + index}</td>
                    <td>
                      <img className="td_cloudimg" src={cloudlog} alt="cloudlog"></img>
                    </td>

                    <td>
                      {Moment(value.updated_date).format("YYYYMMDD_HHmmss")}
                    </td>
                    <td>
                      {value.type}:&nbsp;{value.activity}
                    </td>

                    <td>
                      {Moment(value.created_date).format(
                        "MM-DD-yyyy, HH:mm:ss"
                      )}
                    </td>
                  </tr>
                ))
              )}

              {state.errorMessage && !state.loading ? (
                <tr>
                  <td colSpan="12" align="center">
                    <p
                      style={{
                        color: "red",
                        textAlign: "center",
                        verticalAlign: "middle"
                      }}
                    >
                      {state.errorMessage}
                    </p>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      {state.totalCount > RecordsperPage ? (
        <div
          style={{
            display: "flex",
            width: "100%",
            alignContent: "center",
            justifyContent: "center",
            marginTop: "20px"
          }}
        >
          {state.loading
            ? Array.from({ length: 1 }, (_, index) => (
                <Pagination
                  style={{
                    display: "flex",
                    flexWrap: "nowrap"
                  }}
                  onChange={handlePageChange}
                  count={totalPages}
                  siblingCount={0}
                  disabled
                  boundaryCount={1}
                  page={state.currentPage}
                  color="teal"
                  key={index + 1}
                  className={`pagination-button ${
                    state.currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  {index + 1}
                </Pagination>
              ))
            : Array.from({ length: 1 }, (_, index) => (
                <Pagination
                  style={{
                    display: "flex",
                    flexWrap: "nowrap"
                  }}
                  onChange={handlePageChange}
                  count={totalPages}
                  siblingCount={0}
                  boundaryCount={1}
                  page={state.currentPage}
                  color="teal"
                  key={index + 1}
                  className={`pagination-button ${
                    state.currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  {index + 1}
                </Pagination>
              ))}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
